import { Alert, AlertTitle } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { ExpandableText } from "../../../../../shared/components/text/ExpandableText"
import { LocalizedStrict } from "../../../../localization/components/AppLocalized"

const useStyles = makeStyles()((theme) => ({
    alert: {
        background: theme.palette.tailwind.sky[50],
        borderRadius: ".5rem",
        width: "fit-content",
    },
    title: {
        color: theme.palette.tailwind.sky[700],
        fontWeight: 600,
        margin: 0,
    },
    body: {
        color: theme.palette.tailwind.sky[700],
    },
}))

type OrderNoteAlertProps = Readonly<{
    note: string
    className?: string
}>

export function OrderNoteAlert({ note, className }: OrderNoteAlertProps) {
    const { classes, cx } = useStyles()

    return (
        <Alert icon={false} className={cx(classes.alert, className)}>
            <LocalizedStrict id="production-package-slip-section-note-title">
                <AlertTitle className={classes.title}>Note</AlertTitle>
            </LocalizedStrict>
            <ExpandableText text={note} className={classes.body} />
        </Alert>
    )
}
